import { useFormContext } from 'react-hook-form';
import {
  AccountHoldingDTO,
  AllocationTaxStatusDTO,
} from '../../../../../../../../api/useAccountsQuery';
import { getDefaultAssetAllocation } from '../../../../../../../../helpers';
import { getAllocations } from '../../../../../../../Holdings/utils/getAllocations';
import { FormFields } from '../../../../AccountForm.meta';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';
import { getWeightedAllocation } from '../../utils/getWeightedAllocation';

interface UseSpecificPositionsParams {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
}

export const useSpecificPositions = ({ assetAllocationTaxStatus }: UseSpecificPositionsParams) => {
  const { watch } = useFormContext<FormFields>();

  const [accountType, positions, annuityIsAnnuitized] = watch([
    'bankAccount.AccountType',
    'bankAccount.Positions',
    'bankAccount.AnnuityIsAnnuitized',
  ]);

  const {
    options: { DefaultAssetAllocation },
  } = useAccountFormContext();

  const defaultAssetAllocation = getDefaultAssetAllocation(DefaultAssetAllocation, {
    AccountType: accountType!,
    TaxStatus: assetAllocationTaxStatus!,
    AnnuityIsAnnuitized: annuityIsAnnuitized,
  });

  if (!positions || (positions && positions.length === 0)) {
    return { data: null };
  }

  const specificPositionsList =
    assetAllocationTaxStatus === null
      ? positions
      : positions.filter(position => position.TaxStatus === assetAllocationTaxStatus) || [];

  const aggregatedPositions = (specificPositionsList as AccountHoldingDTO[]).map(getAllocations);

  if (aggregatedPositions.length === 0) {
    return {
      data: null,
    };
  }

  const weightedAllocation = getWeightedAllocation(aggregatedPositions);

  const chartValues = defaultAssetAllocation.map(asset => ({
    ...asset,
    y: weightedAllocation ? weightedAllocation[asset.id] * 100 : asset.y * 100,
  }));

  return {
    data: {
      aggregatedPositions,
      chartValues,
    },
  };
};
